window.ajaxFilter = (function () {
  // Re-run scripts on newly injected HTML
  function reinitUI() {
    console.log("[DEBUG] Reinitializing UI...");
    if (window.initTooltips) window.initTooltips();
    if (window.initMenuDropdowns) window.initMenuDropdowns();
    if (window.initToleranceModals) window.initToleranceModals();
    if (window.initStickyProductBlock) window.initStickyProductBlock();
    if (window.initVendorAction) window.initVendorAction();
    if (window.initVariantDrawer) window.initVariantDrawer();
    if (window.initStripePaymentIntent) window.initStripePaymentIntent();
    if (window.initMarkUpTip) window.initMarkUpTip();
    if (window.initVendorInvoice) window.initVendorInvoice();
    if (window.initVendorShowStock) window.initVendorShowStock();
    if (window.initVendorInventoryUpdate) window.initVendorInventoryUpdate();
    if (window.initVendorInventorySync) window.initVendorInventorySync();
  }

  // 1) handleFilterChange
 async function handleFilterChange(formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error(`[DEBUG] Filter form not found: ${formId}`);
    return;
  }

  // 1) Gather form data
  const formData = new FormData(form);
  console.log("[DEBUG] Step 1 - Raw FormData entries:", Array.from(formData.entries()));

  const queryString = new URLSearchParams(formData).toString();
  console.log("[DEBUG] Step 1 - Query String:", queryString);

  // 2) Build final URL
  const handle = window.currentSubCollectionHandle || "fallback-handle";
  const isProduct = window.currentIsProduct || false;
  const baseUrl = isProduct
    ? `/products/${handle}?view=singleproduct-ajax`
    : `/collections/${handle}?view=subcollection-ajax`;

  const url = queryString ? `${baseUrl}&${queryString}` : baseUrl;
  console.log("[DEBUG] Step 2 - Final Filter URL =>", url);

  try {
    console.log("[DEBUG] Step 3 - Sending AJAX request...");
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`[DEBUG] HTTP error! status: ${response.status}`);
    }

    // 3) Convert response to text
    const rawHtml = await response.text();
    console.log("[DEBUG] Step 3 - Raw HTML length:", rawHtml.length);

    // (Optional) Log a snippet of the raw HTML
    console.log("[DEBUG] Step 3 - Raw HTML snippet:", rawHtml.slice(0, 300), "...");

    // 4) Parse HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(rawHtml, "text/html");
    const variantRows = doc.querySelectorAll("#collection-list-row");

    console.log("[DEBUG] Step 4 - Found #collection-list-row elements:", variantRows.length);

// 5) Convert formData to filters object
// Now storing arrays for each shortKey, so multiple checkboxes become an array
const filters = {};
for (const [key, val] of formData.entries()) {
  if (key.startsWith("filter.v.m.custom.")) {
    const shortKey = key.split(".").pop(); // e.g. "filter_6"

    if (!filters[shortKey]) {
      filters[shortKey] = [];  // initialize array
    }
    filters[shortKey].push(val);
    // so if user selected 1/4 and 1/8, 
    // filters["filter_6"] = ["1/4", "1/8"]
  }
}
console.log("[DEBUG] Step 5 - filters object (array mode):", filters);

// 7) The filtering logic with OR
// If a row has dataAttributeValue that matches ANY of the array values, it passes for that shortKey.
const filteredRows = Array.from(variantRows).filter(row => {
  // For each shortKey in filters
  for (const shortKey in filters) {
    const userSelectedValues = filters[shortKey]; 
    // e.g. ["1/4", "1/8"]

    const numberPart = shortKey.split("_").pop(); 
    const dataAttributeValue = row.getAttribute(`data-filter-${numberPart}`);

    console.log("[DEBUG] Checking row with OR logic:", {
      shortKey,
      userSelectedValues,
      numberPart,
      dataAttributeValue
    });

    if (!dataAttributeValue) {
      console.log(`[DEBUG] => Row missing data-filter-${numberPart} => fail`);
      return false;
    }

    // If row's dataValue is NOT in userSelectedValues => row fails
    // Because user selected *some* values for that shortKey, so row must match at least one
    if (!userSelectedValues.includes(dataAttributeValue)) {
      console.log(`[DEBUG] => dataAttributeValue="${dataAttributeValue}" not in`, userSelectedValues);
      return false;
    }
  }

  // If we never fail, row passes
  return true;
});

    

console.log("[DEBUG] Step 7 - Filtered rows =>", filteredRows.length);

// === SORT step ===
filteredRows.sort((rowA, rowB) => {
  const orderA = parseInt(rowA.getAttribute('data-variant-order') || '999999', 10);
  const orderB = parseInt(rowB.getAttribute('data-variant-order') || '999999', 10);
  return orderA - orderB;
});
console.log("[DEBUG] Sorting by data-variant-order done.");

// Then we append
const tableContainer = document.getElementById("cumulative-variant-table");
if (tableContainer) {
  tableContainer.innerHTML = "";
  if (filteredRows.length) {
    filteredRows.forEach(row => {
      const imported = document.importNode(row, true);
      tableContainer.appendChild(imported);
    });
  } else {
    tableContainer.innerHTML = "<p>No matching variants found.</p>";
  }
}

    console.log("[DEBUG] Re-Reinitializing UI...");
    if (window.initTooltips) window.initTooltips();
    if (window.initMenuDropdowns) window.initMenuDropdowns();
    if (window.initToleranceModals) window.initToleranceModals();
    if (window.initStickyProductBlock) window.initStickyProductBlock();
    if (window.initVendorAction) window.initVendorAction();
    if (window.initVariantDrawer) window.initVariantDrawer();
    if (window.initStripePaymentIntent) window.initStripePaymentIntent();
    if (window.initMarkUpTip) window.initMarkUpTip();
    if (window.initVendorInvoice) window.initVendorInvoice();
    if (window.initVendorShowStock) window.initVendorShowStock();
    if (window.initVendorInventoryUpdate) window.initVendorInventoryUpdate();
    if (window.initVendorInventorySync) window.initVendorInventorySync();
    
    console.log("[DEBUG] Step 8 - UI updated with new rows. Done.");
    // Re-initialize UI, if needed
    if (window.reinitUI) window.reinitUI();

  } catch (err) {
    console.error("[DEBUG] Filter AJAX request error:", err);
  }
}



  // 2) handleFilterDelete
  function handleFilterDelete(paramName) {
    console.log(`[DEBUG] Deleting filter parameter: ${paramName}`);
    const form =
      document.getElementById("js-desktopFilter") ||
      document.getElementById("js-mobileFilter");
    if (!form) {
      console.error("[ERROR] No filter form found to remove param from.");
      return;
    }

    // Remove it from the form data
    const formData = new FormData(form);
    formData.delete(paramName);

    // If price range, also remove relevant keys
    if (paramName.includes("price")) {
      formData.delete("filter.v.price.gte");
      formData.delete("filter.v.price.lte");
    }

    console.log("[DEBUG] Updated FormData after deletion:", Array.from(formData.entries()));

    // Re-apply them to the form so everything stays in sync:
    form.reset();
    for (const [key, val] of formData.entries()) {
      const inputEl = form.querySelector(`[name="${CSS.escape(key)}"]`);
      if (!inputEl) continue;

      // For checkboxes, re-check
      if (inputEl.type === "checkbox" || inputEl.type === "radio") {
        inputEl.checked = true;
      } else {
        inputEl.value = val;
      }
    }

    // Now run handleFilterChange
    handleFilterChange(form.id);
  }

  // 3) handleFilterDeleteAll
  function handleFilterDeleteAll() {
    console.log("[DEBUG] Deleting all filters...");
    const desktopForm = document.getElementById("js-desktopFilter");
    const mobileForm = document.getElementById("js-mobileFilter");

    if (desktopForm) desktopForm.reset();
    if (mobileForm) mobileForm.reset();

    // Then fetch again, e.g., from the desktop form
    if (desktopForm) {
      handleFilterChange("js-desktopFilter");
    } else if (mobileForm) {
      handleFilterChange("js-mobileFilter");
    }
  }

  // Return the public methods
  return {
    handleFilterChange,
    handleFilterDelete,
    handleFilterDeleteAll,
  };
})();
